import React from "react";
import PropTypes from "prop-types";
import { useOutsideClick } from "hooks";
import IoPrinter from "react-icons/lib/io/printer";
import ReactToPrint from "react-to-print";

const PrintOrderBtn = ({ orderRef, setShowNotes }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const printButtonRef = React.useRef();
  useOutsideClick(printButtonRef, () => {
    setIsOpen(false);
  });
  return (
    <ReactToPrint
      trigger={() => (
        <div
          className="no-print print-order-button"
          onContextMenu={e => {
            e.preventDefault();
            setIsOpen(true);
          }}
          ref={printButtonRef}
          onClick={() => {
            window.print();
          }}
        >
          {isOpen ? (
            <div className="print-menu no-print">
              <div
                className="print-option"
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                Print
              </div>
              <div
                className="print-option"
                onClick={e => {
                  e.stopPropagation();
                  setIsOpen(false);
                  setShowNotes(true);
                  setTimeout(() => {
                    window.print();
                    setShowNotes(false);
                  }, 100);
                }}
              >
                Print with Notes
              </div>
            </div>
          ) : (
            <IoPrinter color="grey" size="28px" />
          )}
        </div>
      )}
      content={() => orderRef.current}
    />
  );
};

PrintOrderBtn.propTypes = {
  orderRef: PropTypes.object.isRequired,
  setShowNotes: PropTypes.func.isRequired
};

export default PrintOrderBtn;
